import { Icon } from "@chakra-ui/icons";
import { MdArrowDownward, MdArrowUpward } from "react-icons/md";
import React from "react";
export const SortIcon = ({ isSorted, onClick }) => {
  return /* @__PURE__ */ React.createElement("button", { onClick }, isSorted ? /* @__PURE__ */ React.createElement(Icon, { as: MdArrowUpward, "aria-label": "sorted ascending" }) : /* @__PURE__ */ React.createElement(Icon, { as: MdArrowDownward, "aria-label": "sorted descending" }));
};
